import axios from 'axios';
import { go } from 'react-router-redux';
import {
  goTo,
} from '../../actions/routing';
import config from '../../config';
import tc from '../../assets/tc.json';
// eslint-disable-next-line camelcase
import tc_emma from '../../assets/tc-emma.json';
import pics from '../../assets/pics.json';
// eslint-disable-next-line camelcase
import pics_emma from '../../assets/pics-emma.json';
import { formatFormData } from '../../utils/formData';
import { SERVER_ERROR_CODES } from '../../constants/constants';

export const INITIAL = 'myaxa/signup/INITIAL';
export const CARD_SUBMIT = 'myaxa/signup/CARD_SUBMIT';
export const CARD_SUBMIT_FAIL = 'myaxa/signup/CARD_SUBMIT_FAIL';
export const POLICY_NUMBER_SUBMIT = 'myaxa/signup/POLICY_NUMBER_SUBMIT';
export const CERT_NUMBER_SUBMIT = 'myaxa/signup/CERT_NUMBER_SUBMIT';
export const MEMBERSHIP_NUMBER_SUBMIT = 'myaxa/signup/MEMBERSHIP_NUMBER_SUBMIT';
export const SUBMIT_ENQUIRY = 'myaxa/signup/SUBMIT_ENQUIRY';
export const CONTACT_US = 'myaxa.signup/CONTACT_US';
export const HIDE_ALERT = 'myaxa/signup/HIDE_ALERT';
export const LOAD_TERMS_AND_CONDITIONS = 'myaxa/signup/LOAD_TERMS_AND_CONDITIONS';
export const LOAD_TERMS_AND_CONDITIONS_EMMA = 'myaxa/signup/LOAD_TERMS_AND_CONDITIONS_EMMA';
export const SUBMIT_CREATE_USERNAME = 'myaxa/signup/SUBMIT_CREATE_USERNAME';
export const CREATE_PASSWORD = 'myaxa/signup/CREATE_PASSWORD';
export const CREATE_PASSWORD_FAIL = 'myaxa/signup/CREATE_PASSWORD_FAIL';
export const CHANGE_VALUES = 'myaxa/signup/CHANGE_VALUES';
const SERVER_REQUEST_PENDING = 'myaxa/signup/SERVER_REQUEST_PENDING';
const SERVER_REQUEST_COMPLETE = 'myaxa/signup/SERVER_REQUEST_COMPLETE';
export const HSBC_POLICY = 'myaxa/signup/HSBC_POLICY';
export const RESEND_LINK = 'myaxa/signupLife/RESEND_LINK';

const initialState = {
  token: '',
  submitPasswordComplete: false,
  showAlert: false,
  showError: false,
  errorData: {
    code: '',
    status: null,
    hasError: false,
  },
  groups: [
    {
      label: 'common.email',
      value: 'email',
    },
    {
      label: 'common.mobile',
      value: 'mobile',
    },
  ],
  userData: {},
  error: '',
  title: '',
  description: [],
  descriptionEmma: [],
  hasChangeValues: false,
  serverStatus: null,
  isLoading: false,
  policyInput: '',
  errorCode: '',
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case INITIAL:
      return {
        ...state,
        input: action.input,
        showAlert: false,
        isSubmitSuccessed: false,
      };
    case CARD_SUBMIT:
      return {
        ...state,
        isSubmitSuccessed: true,
        showAlert: !action.customerId,
        hash: action.hash,
        policyNo: action.policyNo,
        certificateNumber: action.certificateNumber,
        dependentNumber: action.dependentNumber,
        membershipNo: action.membershipNo,
        isLoading: false,
      };
    case MEMBERSHIP_NUMBER_SUBMIT:
    case POLICY_NUMBER_SUBMIT:
    case CERT_NUMBER_SUBMIT:
      return {
        ...state,
        isSubmitSuccessed: true,
        isLoading: false,
      };
    case SUBMIT_ENQUIRY:
      return {
        ...state,
        isLoading: false,
      };
    case CONTACT_US:
      return {
        ...state,
        chinaId: action.chinaId,
        hkId: action.hkId,
        passport: action.passport,
        certificateNumber: action.certificateNumber,
        dependentNumber: action.dependentNumber,
        membershipNo: action.membershipNo,
        isLoading: false,
      };
    case CARD_SUBMIT_FAIL:
      return {
        ...state,
        policyNo: action.policyNo,
        certificateNumber: action.certificateNumber,
        dependentNumber: action.dependentNumber,
        membershipNo: action.membershipNo,
        cardType: action.cardType,
        isLoading: false,
        errorCode: action.errorCode,
        ...action.data,
      };
    case HIDE_ALERT:
      return {
        ...state,
        showAlert: false,
        showError: false,
        error: '',
      };
    case LOAD_TERMS_AND_CONDITIONS:
      return {
        ...state,
        title: action.title,
        description: action.description,
        showAlert: false,
        showError: false,
      };
    case LOAD_TERMS_AND_CONDITIONS_EMMA:
      return {
        ...state,
        title: action.title,
        description: action.description,
        showAlert: false,
        showError: false,
      };
    case SUBMIT_CREATE_USERNAME:
      return {
        ...state,
        username: action.username,
        hash: action.hash,
        policyNo: action.policyNo,
        certificateNumber: action.certificateNumber,
        dependentNumber: action.dependentNumber,
        membershipNo: action.membershipNo,
        termsAgreed: action.termsAgreed,
        prospectDisagreed: action.prospectDisagreed,
        eSettlementAgreed: action.eSettlementAgreed,
        email: action.email,
        countryCode: action.countryCode,
        mobile: action.mobile,
        contactType: action.contactType,
        policyType: action.policyType,
        showAlert: false,
      };
    case CREATE_PASSWORD:
      return {
        ...state,
        username: action.username,
        isLoading: false,
      };
    case CREATE_PASSWORD_FAIL:
      return {
        ...state,
        policyNo: action.policyNo,
        certificateNumber: action.certificateNumber,
        dependentNumber: action.dependentNumber,
        membershipNo: action.membershipNo,
        policyType: action.policyType,
        isLoading: false,
        errorCode: action.errorCode,
      };
    case CHANGE_VALUES:
      return {
        ...state,
        hasChangeValues: true,
      };
    case SERVER_REQUEST_PENDING:
      return {
        ...state,
        isLoading: true,
      };
    case SERVER_REQUEST_COMPLETE:
      return {
        ...state,
        isLoading: false,
      };
    case HSBC_POLICY:
      return {
        ...state,
        policyInput: action.policyInput,
      };
    case RESEND_LINK:
      return {
        ...state,
        loginId: action.loginId,
        isSubmitting: false,
      };
    default:
      return state;
  }
}

export const onPolicyNumberSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: POLICY_NUMBER_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/axa-cn`));
  };
};

export const onCertNumberSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: CERT_NUMBER_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/eb/dob`));
  };
};

export const onMembershipNumberSubmit = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: MEMBERSHIP_NUMBER_SUBMIT,
    });
    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/eb/dob`));
  };
};

export const receiveTermsAndConditions = (data, lang) => {
  const title = data[`title_${lang}`];
  const description = data[`description_${lang}`];

  return {
    type: LOAD_TERMS_AND_CONDITIONS,
    title,
    description,
  };
};

export const receiveTermsAndConditionsEmma = (data, lang) => {
  const title = data[`title_${lang}`];
  const description = data[`description_${lang}`];
  return {
    type: LOAD_TERMS_AND_CONDITIONS_EMMA,
    title,
    description,
  };
};

export const loadTermsAndConditions = () => {
  return async (dispatch, getState) => {
    const {
      language: {
        lang,
      },
    } = getState();

    dispatch(receiveTermsAndConditions(tc, lang));
  };
};

export const loadTermsAndConditionsEmma = () => {
  return async (dispatch, getState) => {
    const {
      language: {
        lang,
      },
    } = getState();

    dispatch(receiveTermsAndConditionsEmma(tc_emma, lang));
  };
};

export const loadPICS = () => {
  return async (dispatch, getState) => {
    const {
      language: {
        lang,
      },
    } = getState();

    dispatch(receiveTermsAndConditions(pics, lang));
  };
};

export const loadPICSEmma = () => {
  return async (dispatch, getState) => {
    const {
      language: {
        lang,
      },
    } = getState();

    dispatch(receiveTermsAndConditionsEmma(pics_emma, lang));
  };
};


export const onCardSubmit = (submitValues) => {
  return async (dispatch, getState) => {
    const details = {
      'policyType': submitValues.policyType,
      'cardType': submitValues.cardType,
      'policy': submitValues.policyNo,
      'cert': submitValues.certificateNumber,
      'dependent': submitValues.dependentNumber,
      'member': submitValues.membershipNo,
      'dob': submitValues.dob,
    };
    const formData = formatFormData(details);

    dispatch({
      type: SERVER_REQUEST_PENDING,
    });

    await axios.post(`${config.webview.identityBEUrl}/customer/eb/search`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then(async (response) => {
      dispatch({
        type: SERVER_REQUEST_COMPLETE,
      });
      if (!response.data.checkHash) { // CUSEXP1, CUSEXP2
        dispatch({
          type: CARD_SUBMIT_FAIL,
          policyNo: submitValues.policyNo,
          certificateNumber: submitValues.certificateNumber,
          dependentNumber: submitValues.dependentNumber,
          membershipNo: submitValues.membershipNo,
          cardType: submitValues.cardType,
        });
        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-account-fail`));
      } else if (response.data.iam) {
        if (response.data.iam.status === 'pre-validated') {
          const detailsReactivate = {
            'checkHash': response.data.checkHash,
            'locale': `${getState().language.lang}`,
          };
          const formDataReactivate = formatFormData(detailsReactivate);

          await axios.post(`${config.webview.identityBEUrl}/account/reactivate`, formDataReactivate, {
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
            },
          }).then((response2) => {
            dispatch({
              type: RESEND_LINK,
              loginId: response2.data.loginId,
            });
            dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/resend`));
          }).catch((error) => {
            dispatch({
              type: CARD_SUBMIT_FAIL,
              errorCode: error.response.data.code,
            });
            dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-account-fail`));
          });
        } else { // registered already
          dispatch({
            type: CARD_SUBMIT_FAIL,
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/username-registered`));
        }
      } else {
        dispatch({
          type: CARD_SUBMIT,
          hash: response.data.checkHash,
          policyNo: submitValues.policyNo,
          certificateNumber: submitValues.certificateNumber,
          dependentNumber: submitValues.dependentNumber,
          membershipNo: submitValues.membershipNo,
          data: {
            showAlert: false,
          },
        });

        dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-account`));
      }
    }).catch((error) => {
      if (error.response) {
        const serverErrorCode = error.response.data.code;
        if (SERVER_ERROR_CODES.includes(serverErrorCode)) { // CUSEXP3, CUSEXP7
          dispatch({
            type: CARD_SUBMIT_FAIL,
            policyNo: submitValues.policyNo,
            certificateNumber: submitValues.certificateNumber,
            dependentNumber: submitValues.dependentNumber,
            membershipNo: submitValues.membershipNo,
            cardType: submitValues.cardType,
            errorCode: serverErrorCode,
          });
          dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-account-fail`));
        } else {
          // CUSEXP4 - check date not valid, CUSEXP5 - No rights, pop up message
          dispatch({
            type: CARD_SUBMIT_FAIL,
            policyNo: submitValues.policyNo,
            certificateNumber: submitValues.certificateNumber,
            dependentNumber: submitValues.dependentNumber,
            membershipNo: submitValues.membershipNo,
            cardType: submitValues.cardType,
            errorCode: error.response.data.code,
            data: {
              showAlert: true,
              error: serverErrorCode,
            },
          });
        }
      } else {
        dispatch({
          type: CARD_SUBMIT_FAIL,
          policyNo: submitValues.policyNo,
          certificateNumber: submitValues.certificateNumber,
          dependentNumber: submitValues.dependentNumber,
          membershipNo: submitValues.membershipNo,
          cardType: submitValues.cardType,
          data: {
            showAlert: true,
            error: 'NETWORK',
          },
        });
      }
    });
  };
};

export const submitCreateUsername = (submitValues) => {
  return (dispatch, getState) => {
    const {
      language: {
        lang,
      },
    } = getState();
    dispatch({
      type: SUBMIT_CREATE_USERNAME,
      hash: submitValues.hash,
      username: submitValues.username,
      policyNo: submitValues.policyNo,
      certificateNumber: submitValues.certificateNumber,
      dependentNumber: submitValues.dependentNumber,
      membershipNo: submitValues.membershipNo,
      hkId: submitValues.hkId,
      chinaId: submitValues.chinaId,
      passport: submitValues.passport,
      policyType: submitValues.policyType,
      termsAgreed: submitValues.termsAgreed,
      prospectDisagreed: submitValues.prospectDisagreed,
      eSettlementAgreed: submitValues.eSettlementAgreed,
      countryCode: submitValues.countryCode,
      mobile: submitValues.mobile,
      email: submitValues.email,
      contactType: submitValues.contactType,
    });

    dispatch(goTo(`/${lang}/${config.webview.identityFEPath}/registration/create-password`));
  };
};

export const submitCreatePassword = (values) => {
  // values.policyType
  return async (dispatch, getState) => {
    const details = {
      'checkHash': values.hash,
      'contactType': values.contactType,
      'email': values.email,
      'countryCode': values.countryCode,
      'mobile': values.mobile,
      'password': values.password,
      'acceptDataPolicy': values.termsAgreed,
      'receiveNews': values.prospectDisagreed,
      'receiveClaimSettle': values.eSettlementAgreed || 'false',
      'locale': `${getState().language.lang}`,
      'analyticsId': null,
    };
    const formData = formatFormData(details);

    dispatch({
      type: SERVER_REQUEST_PENDING,
    });

    await axios.post(`${config.webview.identityBEUrl}/account/register`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      dispatch({
        type: CREATE_PASSWORD,
        username: response.data.loginId,
      });
      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/create-password-success`));
    }).catch((error) => {
      // REGEXP1, REGEXP2, REGEXP3, REGEXP
      dispatch({
        type: CREATE_PASSWORD_FAIL,
        hash: values.hash,
        policyNo: values.policyNo,
        certificateNumber: values.certificateNumber,
        dependentNumber: values.dependentNumber,
        membershipNo: values.membershipNo,
        policyType: values.policyType,
        errorCode: error.response.data.code,
      });
      dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/username-used`));
    });
  };
};

export const initial = () => {
  return {
    type: INITIAL,
  };
};

export const onSelectOtherUsername = () => {
  return async (dispatch) => {
    dispatch(go(-2));
  };
};

export const onContactUs = (query) => {
  return async (dispatch, getState) => {
    dispatch({
      type: CONTACT_US,
      chinaId: query.chinaId,
      hkId: query.hkId,
      passport: query.passport,
      policyNo: query.policyNo,
      certificateNumber: query.certificateNumber,
      dependentNumber: query.dependentNumber,
      membershipNo: query.membershipNo,
    });

    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/submit-enquiry`));
  };
};

export const onSubmitEnquiry = () => {
  return async (dispatch, getState) => {
    // TODO Submit Query API
    dispatch({
      type: SUBMIT_ENQUIRY,
    });

    dispatch(goTo(`/${getState().language.lang}/${config.webview.identityFEPath}/registration/submit-enquiry-success`));
  };
};

export const hasChangeValues = () => {
  return (dispatch) => {
    dispatch({
      type: CHANGE_VALUES,
    });
  };
};

export const hideAlert = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_ALERT,
    });
  };
};
